import {
  Directive,
  EmbeddedViewRef,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef
} from "@angular/core";
type FunctionKey = (row: any) => string;

@Directive({
  selector: "[pageDatagridColumnCellTemplate]",
  standalone: false
})
export class PageDatagridColumnCelltemplateDirective {
  @Input("pageDatagridColumnCellTemplateKeyFn")
  keyFn: FunctionKey | undefined;

  private readonly embeddedViewRefMap: Record<string, EmbeddedViewRef<any>> =
    {};

  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainerRef = inject(ViewContainerRef);

  render(renderData: { container: HTMLElement; row: any }): void {
    const key: string = this.keyFn
      ? this.keyFn(renderData.row)
      : renderData.row["id"];

    let embeddedViewRef = this.embeddedViewRefMap[key];

    if (!embeddedViewRef) {
      embeddedViewRef = this.viewContainerRef.createEmbeddedView(
        this.templateRef,
        {
          row: renderData.row
        }
      );
    }

    if (renderData.container) {
      renderData.container.append(embeddedViewRef.rootNodes[0]);
    }

    this.embeddedViewRefMap[key] = embeddedViewRef;

    return embeddedViewRef.rootNodes[0];
  }

  static ngTemplateContextGuard(
    directive: PageDatagridColumnCelltemplateDirective,
    context: unknown
  ): context is { row: any } {
    return true;
  }
}
